import React from "react"
import { useSelector } from "react-redux"
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization"
import { adminAccountCallLogStatusUrl } from "../../services/urls"
import { CreateCallStatusForm } from "./create"
import AccountCallLogStatusDetail from "./detail"

export const AccountCalls = () => {
    const localize = useSelector(getLocalized);
    const columns = [
        {
            dataField : "Name",
            caption : localize.getString("name")
        },
        {
            dataField : "Description",
            caption : localize.getString("description")
        }
    ]
   
    return <DataGrid
        columns={columns}
        url={adminAccountCallLogStatusUrl}
        getByIdUrl={adminAccountCallLogStatusUrl}
        refObject={{}}
        create={{
            width: "45%",
            height: "42%",
            createUrl: adminAccountCallLogStatusUrl,
            title: localize.getString("callStatusCreate"),
            component: CreateCallStatusForm,
            validationGroup: "createAccountCallStatus",
        }}
        title={localize.getString("callStatues")}
        remove={{
            url:adminAccountCallLogStatusUrl
        }}
        edit={{   
            component : CreateCallStatusForm, 
            width:"50%",
            height : "50%",
            editUrl :adminAccountCallLogStatusUrl,
            title : localize.getString("callStatusEdit")
            
        }}

        details={{
            width: "50%",
            height: "50%",
            getByIdUrl: adminAccountCallLogStatusUrl,
            title: localize.getString("callStatusDetail"),
            component: AccountCallLogStatusDetail,
        }}
        
    />


}